import Alpine from 'alpinejs';
import intersect from '@alpinejs/intersect';
import resize from '@alpinejs/resize'

Alpine.plugin(resize);
Alpine.plugin(intersect);

document.addEventListener('alpine:init', () => {
	Alpine.store('logoSwiper', {
		hover: false,
        pauseTransform: null,
		pause(element) {
            const swiper = element.swiper;
            const translate = swiper.getTranslate();

            swiper.setTranslate(translate);
            swiper.autoplay.stop();
		},
        resume(element) {
            const swiper = element.swiper;

            swiper.slideTo(swiper.activeIndex, 1500, false );
            swiper.autoplay.start();
        }
	});

    Alpine.data('countAnimationComponent', () => ({
        showArrow: false,
        // This function will be called by x-intersect
        startCountAnimation(element, speed = 2) {
            const destination = parseInt(element.dataset.countTo, 10);

            // Create a dummy object for GSAP to animate
            const counter = { value: 0 };

            gsap.to(counter, {
                value: destination,
                duration: speed,
                ease: "power2.out",
                onUpdate: () => {
                    element.textContent = Math.round(counter.value).toLocaleString('nl-NL');
                },
                onComplete: () => {
                    this.showArrow = true;
                }
            });
        },
        resetCountAnimation(element) {
            // Reset the count animation
            element.textContent = '0';
            this.showArrow = false;
        }
    }));
});

window.Alpine = Alpine;
Alpine.start();
